import { CalendarMode } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Pageable, { PageEventListener } from '@philips-emr/tws-core/lib/component/types/pageable';
import { isEnumValid } from '@philips-emr/tws-utils';

import { RangeState } from './constants';

export interface Range {
  startDate: string;
  endDate: string;
}

class CalendarAPI extends ComponentAPI implements Clickable, Pageable {

  /** @event */
  @AwesomeEvent
  onAddNew = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onNextPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onPrevPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onEventClick = new ClickEventListener();

  isCanChangeMode(): boolean {
    return this.state.canChangeMode;
  }

  setCanChangeMode(canChangeMode: boolean): void {
    this.setState({ canChangeMode });
  }

  getData(): object {
    return this.state.data;
  }

  setData(data: object|object[]): void {
    if (!Array.isArray(data)) {
      this.setState({ data });
    }
  }

  getDate(): string {
    return this.state.date;
  }

  setDate(date: string): void {
    this.setState({ date });
  }

  getEndOfDay(): number {
    return this.state.endOfDay;
  }

  setEndOfDay(endOfDay: number): void {
    this.setState({ endOfDay });
  }

  isLoading(): boolean {
    return this.state.loading;
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }

  getMode(): CalendarMode {
    return this.state.mode;
  }

  setMode(mode: CalendarMode): void {
    if (isEnumValid(CalendarMode, mode)) {
      this.setState({ mode });
    }
  }

  getStartOfDay(): number {
    return this.state.startOfDay;
  }

  setStartOfDay(startOfDay: number): void {
    this.setState({ startOfDay });
  }

  getRanges(): Range[] {
    return [...(this.state.ranges || [])];
  }

  setRanges(ranges: Range[]): void {
    this.setState({ ranges });
  }

  addRange(startDate: string, endDate: string): void {
    const ranges = this.getRanges();
    ranges.push({ startDate, endDate });
    this.setRanges(ranges);
  }

  addRanges(ranges: Range[]): void {
    const oldRanges = this.getRanges();
    this.setRanges(oldRanges.concat(ranges));
  }

  clearRanges(): void {
    this.setRanges([]);
  }

  setRangeState(rangeState: RangeState): void {
    this.setState({ rangeState });
  }

  getRangeState(): RangeState {
    return this.state.rangeState;
  }
}

export default CalendarAPI;
